import { render } from "./BotPkIndexView.vue?vue&type=template&id=51260610&scoped=true"
import script from "./BotPkIndexView.vue?vue&type=script&lang=js"
export * from "./BotPkIndexView.vue?vue&type=script&lang=js"

import "./BotPkIndexView.vue?vue&type=style&index=0&id=51260610&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51260610"]])

export default __exports__